exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".page_home_download .v-list a{text-decoration:none}.page_home_download .v-chip__content{font-size:1.5rem}", ""]);

